import ColorByStatus from './ColorByStatus'

function GridUnbalanceStatus({ able, fixed }) {
  const error = !fixed || !able
  const fixedStatus = fixed
    ? 'Corregido'
    : !able
    ? 'Deshabilitado'
    : 'Pendiente'

  return <ColorByStatus error={error} message={fixedStatus} />
}

export default GridUnbalanceStatus
